const setHeight = {
  el: document.querySelectorAll(".jsSetHeight") as NodeListOf<HTMLElement>,
  init() {
    this.setHeight()
  },
  setHeight() {
    this.el.forEach((item) => {
      const widht = item.dataset.width ? item.dataset.width : "999999"
      if (window.innerWidth < +widht) {
        const reduce = item.dataset.reduce ? +item.dataset.reduce : 0
        const height = window.innerHeight - reduce + "px"
        item.style.height = height
      }
    })
  },
}

export default setHeight
